import React from "react";
import "./ParagraphField.css";
import HtmlElement from "../../common/HtmlElement";
import type { StandardFieldProps } from "../types";

const ParagraphField: React.FC<StandardFieldProps> = (props) => {
  return (
    <div className="main-container mb-2">
      <HtmlElement elements={props.value as string} />
    </div>
  );
};

export default ParagraphField;
